import { defineStore } from "pinia";
import { useHttpStore } from "@/stores/http";

export const useDistributorStore = defineStore("distributor", () => {
  const httpStore = useHttpStore();

  const getDistributors = (emailAddress) => {
    var params = {
      emailAddress
    };
    return new Promise((resolve, reject) => {
      httpStore
        .api("get", "distributor/GetDistributors", params)
        .then((res) => {
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  };

  const getSuperDistiLinkedList = (emailAddress) => {
    var params = {
        emailAddress: emailAddress
    };
    return new Promise((resolve, reject) => {
      httpStore
        .api("get", "distributor/GetSuperDistiLinkedList", params)
        .then((res) => {
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  };

  const superDistiAddLink = (emailAddress, affinityId, accountName, country) => {
    var params = {
        linkItemData: {
            emailAddress,
            affinityId,
            accountName,
            country
        }
    };
    return new Promise((resolve, reject) => {
      httpStore
        .api("post", "distributor/SuperDistiAddLink", params)
        .then((res) => {
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  };

  const superDistiRemoveLink = (userAffinityLinkId) => {
    var params = {
        userAffinityLinkId
    };
    return new Promise((resolve, reject) => {
      httpStore
        .api("post", "distributor/SuperDistiRemoveLink", params)
        .then((res) => {
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  };

  const getDistributorCompanyBy = (searchBy) => {
    var params = { searchBy };
    return new Promise((resolve, reject) => {
      httpStore
        .api("get", "distributor/GetDistributorCompanyBy", params)
        .then((res) => resolve(res))
        .catch((error) => reject(error));
    });
  };

  const getDistributorRecordsForAdmin = (searchBy) => {
    var params = { searchBy };
    return new Promise((resolve, reject) => {
      httpStore
        .api("get", "distributor/GetDistributorRecordsForAdmin", params)
        .then((res) => resolve(res))
        .catch((error) => reject(error));
    });
  };

  const updateDistributorStatusAndDataFilter = (payload) => {
    return new Promise((resolve, reject) => {
      httpStore
        .api("post", "distributor/UpdateDistributorStatusAndDataFilter", payload)
        .then((res) => resolve(res))
        .catch((error) => reject(error));
    });
  };

  const getDistributor = (searchBy) => {
    var params = { searchBy };
    return new Promise((resolve, reject) => {
      httpStore
        .api("get", "distributor/GetDistributor", params)
        .then((res) => resolve(res))
        .catch((error) => reject(error));
    });
  };

  const getDistributorAuditLog = (distributorId) => {
    var params = { distributorId };
    return new Promise((resolve, reject) => {
      httpStore
        .api("get", "distributor/GetDistributorAuditLog", params)
        .then((res) => resolve(res))
        .catch((error) => reject(error));
    });
  };

  const lookupAffinityForAddDistributor = (affinityId) => {
    var params = { affinityId };
    return new Promise((resolve, reject) => {
      httpStore
        .api("get", "distributor/LookupAffinityForAddDistributor", params)
        .then((res) => resolve(res))
        .catch((error) => reject(error));
    });
  };

  const createDistributor = (payload) => {
    return new Promise((resolve, reject) => {
      httpStore
        .api("post", "distributor/CreateDistributor", payload)
        .then((res) => resolve(res))
        .catch((error) => reject(error));
    });
  };

  return {
    getDistributors,
    getSuperDistiLinkedList,
    superDistiAddLink,
    superDistiRemoveLink,
    getDistributorCompanyBy,
    getDistributorRecordsForAdmin,
    updateDistributorStatusAndDataFilter,
    getDistributor,
    getDistributorAuditLog,
    lookupAffinityForAddDistributor,
    createDistributor
  };
});
